import React from 'react';
import CircularLoading from '@/components/Shared/CircularLoading';
import { StepLoadingWrapper } from './styles';

interface IStepLoadingProps {
  text: string;
  loadingSize?: number;
}

const StepLoading = (props: IStepLoadingProps): React.JSX.Element => {
  return (
    <StepLoadingWrapper>
      <h2>{props.text}</h2>
      <CircularLoading size={props.loadingSize} />
    </StepLoadingWrapper>
  );
};

export default StepLoading;
